module.exports = __webpack_public_path__ + "static/media/dislike.fad538ce.svg";